import { getHttpsCallable } from './firebase-functions-service';
export function SendEventService(commonData) {
    const callable = getHttpsCallable('bigQueryEventCreate');
    return {
        send: (input) => callable
            .then((f) => f({ ...commonData, ...input, origin: commonData.origin, sendAt: new Date().getTime() }))
            .then((result) => result.data),
    };
}
